import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconStyleColor';
/** Renders an SVG icon. */
const SvgStyleColor = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M15.944 29.999c2.528.01 4.425-2.183 4.165-4.637l-.032-.238c-.46-2.841 2.175-5.511 5.047-5.046l.238.031c2.375.252 4.506-1.517 4.632-3.923l.006-.243C29.966 8.43 23.83 2.196 16.352 2.005L15.996 2C8.388 2.002 2.2 8.073 2.005 15.635L2 15.996C1.998 23.626 8.31 29.973 15.944 30ZM4.004 15.687C4.17 9.204 9.475 4.002 15.996 4l.306.004C22.7 4.168 27.972 9.52 28 15.952a2.18 2.18 0 0 1-2.304 2.178l-.252-.026c-4.23-.686-8.018 3.163-7.34 7.34l.026.252a2.18 2.18 0 0 1-1.93 2.291l-.249.013C9.42 27.978 3.998 22.526 4 15.996z"
      />
      <path
        fill="currentColor"
        d="M14 22.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m-7-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m1-7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m5-2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m3 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0"
      />
    </svg>
  );
};
SvgStyleColor.displayName = displayName;
export default SvgStyleColor;
